import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/firmen")({
  component: CompaniesLayout,
});

function CompaniesLayout() {
  return <Outlet />;
}
